<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col ">
    <div class="mb-3 flex items-start gap-4">
      <div class="text-sm text-gray-700">
        One row per master rule from Utilities &gt; AI Guidelines. To change a rule for this program only, type in
        Program Override. The AI reads the master, then the overrides above, then this one; the narrowest wins where
        they differ.
      </div>
      @if (!isReadOnly()) {
        <p-button class="ml-auto shrink-0" (click)="onClear()" size="small" label="Clear" icon="pi pi-eraser"
          [disabled]="grid.ownOverrides().length === 0"
          pTooltip="Remove all the overrides of this program. Each rule then follows the level above."></p-button>
      }
    </div>
    <div class="grow">
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="grid.rows"></prox-ag-grid>
    </div>
  </div>
</div>
